import "./core.css"

function Core(){
    return(
        <div className="Core">
           <h1>Our Core values</h1>
           <p>These principles guide every decision we make and every relationship we build</p>
           <div className="flex">
            
            <div className="core0">
                      <div style={{margin:"20px"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="#F8D47A" stroke="#F8D47A" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.3"></g>
                        <path fill="#F8D47A" d="M11.5 3.11L19 6.63v5.01c0 4.81-3.22 9.26-7.5 10.4C7.22 20.9 4 16.45 4 11.64V6.63m7.5 16.44c4.9-1.23 8.5-6.13 8.5-11.43V6l-8.5-4L3 6v5.64c0 5.3 3.6 10.2 8.5 11.43"/></svg>
                      </div>
                      <h1>Integrity</h1>
                      <p>We operate with unwavering ethical standards, 
                        ensuring transparency in every transaction.</p>
                </div>
                
                <div className="core0">
                    <div style={{margin:"20px"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="none" stroke="#F8D47A" stroke-linecap="round" stroke-width="0.5">
                        <path stroke-linejoin="round" d="m21 6l-5.293 5.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 0-1.414 0L7 14"/><path d="M3 3v14.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21H21"/></g></svg>
                </div>
                <h1>Results</h1>
                <p>Our track record speaks for itself with consistent 
                    above-market returns and strategic portfolio growth.</p>
                </div>
                <div className="core0">
                    <div style={{margin:"20px"}}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="none" stroke="#F8D47A" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5" margin-top="20px"><path d="M6 9a6 6 0 1 0 12 0A6 6 0 1 0 6 9"/>
                      <path d="m12 15l3.4 5.89l1.598-3.233l3.598.232l-3.4-5.889M6.802 12l-3.4 5.89L7 17.657l1.598 3.232l3.4-5.889"/></g></svg>
                </div>
                <h1>Excellence</h1>
                <p>Award-winning strategies and recognized industry 
                    leadership in investment management.</p>
                </div>
                <div className="core0">
                    <div style={{margin:"10px"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="none" stroke="#F8D47A" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></g></svg>
                    </div>
                    <h1>Client Centric</h1>
                    <p>Your goals are our priority. We tailor every strategy 
                        to your unique financial aspirations.</p>
                </div>
           </div>
            <div className="core1">
                <div className="core0">
                      <div style={{margin:"20px"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="#F8D47A" stroke="#F8D47A" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.3"></g>
                        <path fill="#F8D47A" d="M11.5 3.11L19 6.63v5.01c0 4.81-3.22 9.26-7.5 10.4C7.22 20.9 4 16.45 4 11.64V6.63m7.5 16.44c4.9-1.23 8.5-6.13 8.5-11.43V6l-8.5-4L3 6v5.64c0 5.3 3.6 10.2 8.5 11.43"/></svg>
                      </div>
                      <h1>Integrity</h1>
                      <p>We operate with unwavering ethical standards, 
                        ensuring transparency in every transaction.</p>
                </div>
                <div className="core0">
                    <div style={{margin:"20px"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="none" stroke="#F8D47A" stroke-linecap="round" stroke-width="0.5">
                        <path stroke-linejoin="round" d="m21 6l-5.293 5.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 0-1.414 0L7 14"/><path d="M3 3v14.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21H21"/></g></svg>
                </div>
                <h1>Results</h1>
                <p>Our track record speaks for itself with consistent 
                    above-market returns and strategic portfolio growth.</p>
                </div>
            </div>
            <div className="core1">
                <div className="core0">
                    <div style={{margin:"20px"}}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="none" stroke="#F8D47A" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5" margin-top="20px"><path d="M6 9a6 6 0 1 0 12 0A6 6 0 1 0 6 9"/>
                      <path d="m12 15l3.4 5.89l1.598-3.233l3.598.232l-3.4-5.889M6.802 12l-3.4 5.89L7 17.657l1.598 3.232l3.4-5.889"/></g></svg>
                </div>
                <h1>Excellence</h1>
                <p>Award-winning strategies and recognized industry 
                    leadership in investment management.</p>
                </div>
                <div className="core0">
                    <div style={{margin:"10px"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><g fill="none" stroke="#F8D47A" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></g></svg>
                    </div>
                    <h1>Client Centric</h1>
                    <p>Your goals are our priority. We tailor every strategy 
                        to your unique financial aspirations.</p>
                </div>
            </div>
        </div>
    )
}

export default Core